<a [routerLink]="url">{{text}}</a>